import React, { useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import "./index.scss";
import Header from "../appLayout/header";
import { EnvelopeFillIcon } from "../../assets/icons/EnvelopeFillIcon";
import { LockFillIcon } from "../../assets/icons/LockFillIcon";
import { loginClient } from "../../services/auth";
import { BsLockFill, BsUnlockFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import img from "../../assets/images/img-cart.png";
export default function LoginSection() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const isFormValid =
    formData.email.trim() !== "" && formData.password.trim() !== "";

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isFormValid) return;

    setIsLoading(true);
    setError("");

    try {
      // ✅ use service instead of fetch
      const result = await loginClient(formData.email, formData.password);

      if (result.success) {
        window.location.href = "/payment";
      } else {
        setError(result.msg || "Email ou mot de passe incorrect");
      }
    } catch (err) {
      setError("Erreur de connexion. Veuillez réessayer.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="p-md-5 p-0 pt-md-3">
        <Header />
      </div>
      <div className="login-section container">
        <Row className="g-5">
          {/* Partie gauche : Connexion */}
          <Col md={6} className="login-left">
            <h2 className="title  mt-5">CONNEXION</h2>
            <p className="subtitle">
              connectez - vous creéz un compte ou <br />
              continuez en tant que invité
            </p>

            <h6 className="client-title">CLIENT</h6>
            <p className="client-text mt-3">
              SI VOUS POSSEDEZ DÉJÀ UN COMPTE CONNECTEZ-
              <br />
              VOUS À L’AIDE DE VOTRE ADRESSE EMAIL
            </p>

            <Form onSubmit={handleSubmit}>
              <div className="login-fields mt-5">
                {/* Champ Email */}
                <div className="input-group mb-3 email">
                  <span className="input-group-text">
                    <EnvelopeFillIcon />
                  </span>
                  <Form.Control
                    type="email"
                    placeholder="EMAIL*"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="input-group mb-3">
                  {/* Icône cadenas qui bascule */}
                  <span
                    className="input-group-text toggle-password"
                    role="button"
                    onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <BsUnlockFill /> : <LockFillIcon />}
                  </span>

                  {/* Champ mot de passe */}
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder="MOT DE PASSE*"
                    value={formData.password}
                    onChange={handleInputChange}
                    name="password"
                    required
                  />
                </div>
                {error && <div className="login-error">{error}</div>}
                {/* Champ Mot de passe */}
              </div>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <a href="/forgot-password" className="forgot-link">
                  Mot de passe oublié
                </a>
              </div>

              <Button type="submit" className="btn-submit w-100 mt-3">
                {isLoading ? "CONNEXION EN COURS..." : "Valider la commande"}
              </Button>
            </Form>
          </Col>

          {/* Partie droite : Nouveau client */}
          <Col md={6}>
            <div className="login-right ">
              <h2 className="title-l mb-4 ">NOUVEAU CLIENTS</h2>
              <button
                className="btn-create w-100 mb-3"
                onClick={() => navigate("/register")}>
                CRÉER UN COMPTE
              </button>
              <button
                className="w-100 btn-create-t"
                onClick={() => navigate("/payment")}>
                CONTINUEZ EN TANT QUE INVITÉ
              </button>
            </div>
            <div className="margin-img">
              {" "}
              <img className="img-fluid mt-4  w-100" src={img} />
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}
